
window.onload = () => {

    const btnWrapper = document.querySelector('#add_to_cart_btn_container')

    const productSelect = document.querySelector('#product_select');



    btnWrapper.dataset.pass == ""

    productSelect.addEventListener('change', (e) => {

        // console.log(e.target.value);

        // on remplace la valeur de notre id produit en panier
        document.querySelector('#hidden_product_id').value = e.target.value

        btnWrapper.dataset.pass = "true";

        // Changement de notre url 

        let url = new URLParse(window.location.href, true)
        url.query.variant = e.target.value
        window.history.replaceState(null, null, url.toString())


    })

    /*
    
        productOptions.forEach(productOption => {
            productOption.addEventListener('click', (e) => {
    
                let currentValue = e.target
    
                // on remplace la valeur de notre id produit en panier
                document.querySelector('#hidden_product_id').value = currentValue.dataset.variantId
    
    
                // on efface les conteneurs avec fonds antérieurs
                productOptions.forEach(p => {
    
                    p.classList.contains('current_selected') ? p.classList.remove('current_selected') : null
                })
    
                // on distingue l'élément cliqué et on colorie le conteneur 
                if (currentValue.classList.contains('option_title')) {
    
                    currentValue.parentElement.classList.add('current_selected')
                } else {
                    currentValue.classList.add('current_selected')
                }
    
                // on débloque l'ajout au panier 
    
                btnWrapper.dataset.pass = "true";
    
                // Changement de notre url 
    
                let url = new URLParse(window.location.href, true)
                url.query.variant = currentValue.dataset.variantId
                window.history.replaceState(null, null, url.toString())
    
    
    
    
            });
        });
    */

}
